// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-40f3eed6]{display:none}.gallery-mobile[data-v-40f3eed6]{display:grid;grid-template-columns:repeat(2,1fr);grid-gap:8px;gap:8px}.desktop-gallery-card[data-v-40f3eed6]{overflow:hidden}@media(min-width:1223px){.desktop-gallery-card[data-v-40f3eed6]{max-width:calc(16.66667% - 20px)}[data-v-40f3eed6] .sf-carousel .glide__slides{margin:0 2px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
